;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { shuffle } from 'utils';

/**
 * Filter recipes based on filters array
 * Checks weather, keywords, and attributes
 */
export const filterRecipes = (allRecipes, filters, recipesConfig) => {
    // Step 1: Resolve filter keywords to attribute IDs
    const validFilterIds = {};

    filters.forEach(filterKeyword => {
        Object.entries(recipesConfig).forEach(([categoryKey, category]) => {
            if (!category.options) return;

            // Find options that match the filter keyword
            const matchingOptions = category.options.filter(
                option =>
                    option.slug === filterKeyword ||
                    option.label
                        ?.toLowerCase()
                        .includes(filterKeyword.toLowerCase())
            );

            if (matchingOptions.length > 0) {
                const optionIds = matchingOptions.map(option =>
                    String(option.id)
                );

                if (validFilterIds[categoryKey]) {
                    // Merge with existing IDs for this category
                    validFilterIds[categoryKey] = [
                        ...new Set([
                            ...validFilterIds[categoryKey],
                            ...optionIds,
                        ]),
                    ];
                } else {
                    validFilterIds[categoryKey] = optionIds;
                }
            }
        });
    });

    // Step 2: Filter recipes
    const filteredRecipes = allRecipes.filter(recipe => {
        // Check weather field
        const weatherMatch =
            recipe.weather &&
            filters.some(filter => {
                const filterLower = filter.toLowerCase();
                // Check if recipe's weather array includes this filter
                return Array.isArray(recipe.weather)
                    ? recipe.weather.some(w => w.toLowerCase() === filterLower)
                    : recipe.weather.toLowerCase() === filterLower;
            });

        if (weatherMatch) {
            return true;
        }

        // Check keywords
        const keywordMatch =
            recipe.keywords &&
            Array.isArray(recipe.keywords) &&
            recipe.keywords.length > 0 &&
            recipe.keywords.some(keyword =>
                filters.some(
                    filter =>
                        keyword.toLowerCase().includes(filter.toLowerCase()) ||
                        filter.toLowerCase().includes(keyword.toLowerCase())
                )
            );

        if (keywordMatch) {
            return true;
        }

        // Check attributes
        const attributeMatch =
            recipe.attributes &&
            Object.keys(validFilterIds).length > 0 &&
            Object.entries(validFilterIds).some(([categoryKey, filterIds]) => {
                const recipeAttributeValue = recipe.attributes[categoryKey];

                if (Array.isArray(recipeAttributeValue)) {
                    return filterIds.some(filterId =>
                        recipeAttributeValue.includes(filterId)
                    );
                } else {
                    return filterIds.includes(String(recipeAttributeValue));
                }
            });

        return attributeMatch;
    });

    // Step 3: Shuffle and limit to 12 recipes
    return shuffle(filteredRecipes).slice(0, 12);
};
